import { EmojiPickerViewState } from '../store/schema/EmojiPickerViewState';
import getPopularEmoji from './getPopularEmoji';

export default function createEmojiPickerViewState(): EmojiPickerViewState {
    return {
        emojiResults: getPopularEmoji(),
    };
}
